import { render, staticRenderFns } from "./ConfirmActivateBlock.vue?vue&type=template&id=4d037a04&scoped=true"
import script from "./ConfirmActivateBlock.vue?vue&type=script&lang=js"
export * from "./ConfirmActivateBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d037a04",
  null
  
)

export default component.exports